
<ngx-json-ld [json]="productSchema"></ngx-json-ld>
<div class="about-banner">
  <img src="assets/images/aboutus-banner.jpg" alt="aboutus banner">
</div>
<ul class="about-tabs tabmenubar d-flex justify-content-center flex-wrap">
  <li> <a href="#sec1a" class="btn active"> Our Mission </a></li>
  <li> <a href="#sec2a" class="btn"> Our Values </a></li>
  <li> <a href="#sec3a" class="btn"> The Founder </a></li>
</ul>
<section class="section about-bookwellness">
  <div class="container">
    <div class="sec-head">
      <h2>About Mylifewell </h2>
      <p>
        <strong>We have a simple mission:</strong>
        to help improve personal and social wellbeing for clients all over the world.
      </p>
      <p>
        It’s not news to anyone that we live in an unwell world. With our “always on” culture, it seems easier to become overwhelmed with stress, anxiety, anger, and even depression than it does to find balance. We’re spending more time in front of our screens and less time with those that mean the most to us. We’re eating more, sleeping less and not getting out nearly as much as we should.
      </p>
    </div>
  </div>
</section>

<app-mission> </app-mission>
<h2 class="values-head">We’re your one stop shop for all things wellness.
</h2>
<section class="values-section" id="sec2a">
  <div class="container">
    <div class="values-content d-flex justify-content-between flex-wrap align-items-center">
      <div class="value-points">
        <h2>Our Core Values:</h2>
        <strong>Authenticity, Integrity, Community, Inclusivity, Innovation
        </strong>
        <p>We believe in being who we are, standing behind our word, helping each other out, making sure everyone feels included and charting the course towards healthier living.
        </p>
      </div>
      <figure class="value-image">
        <img src="assets/images/service.png" alt="service">
      </figure>
    </div>
  </div>
</section>
<app-founder> </app-founder>
<!-- <app-why-book-with-us [child]="parent"></app-why-book-with-us> -->
<!--<app-subscribe> </app-subscribe>-->
<!-- <app-testimonials> </app-testimonials> -->
